<template>
  <div class="animated fadeIn">
    <div v-if="issub">
      <subcategory @subcategory="issub = false" :item="id"></subcategory>
    </div>
    <b-row v-if="!issub">
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <strong>View Service Request</strong>
            <eb-button
              classic="mr-1 btn-primary"
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('view', e)"
            ></eb-button>
          </div>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Scope" label-for="Scope" :label-cols="3">
                <b-form-input
                  type="text"
                  id="scope"
                  placeholder="Scope"
                  v-model="itemObj.Scope"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Category"
                label-for="Category"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="category"
                  v-model="itemObj.Category"
                  placeholder="Category"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Topic" label-for="Topic" :label-cols="3">
                <b-form-input
                  type="text"
                  id="topic"
                  placeholder="Topic"
                  disabled
                  v-model="itemObj.topic"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Description"
                label-for="Description"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="description"
                  placeholder="Description"
                  disabled
                  v-model="itemObj.description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <eb-button
                class="btn float-right mr-4"
                classic="mr-1 btn-primary"
                text="Add Sub Category"
                icon="fa fa-plus-circle mr-1"
                iconSide="left"
                @click="category()"
              ></eb-button>
            </b-col>
            <b-col md="12">
              <b-table
                :dark="dark"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                id="my-table"
                :items="Subcategorys"
                :current-page="currentPage"
                :per-page="perPage"
                thead-class="header"
                class="mt-3 tableRadius"
                :fields="Columns"
              ></b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <!-- <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="e => $emit('view', e)"
              ></eb-button> -->
            </b-col>
            <b-col>
              <div style="float: right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="Subcategorys.length"
                  aria-controls="my-table"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";
import subcategory from "@/components/MasterSetup/ServiceRequest/Subcategory.vue";
export default {
  name: "Viewrequest",
  components: {
    ebButton,
    cInput,
    ebSelect,
    subcategory,
  },
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      issub: false,
      perPage: 5,
      striped: false,
      hover: true,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      Columns: [
        {
          key: "Category",
          sortable: true,
        },
        {
          key: "Description",
        },
        {
          key: "Scope",
        },

        {
          key: "Severity",
        },
      ],
    };
  },
  computed: {
    Subcategorys() {
      let data = this.$store.getters["servicerequest/GetSubcategoryList"];
      console.log("sub", data);
      let SubcategoryList = [];
      console.log("list", SubcategoryList);
      if (Array.isArray(data.data) && data.data.length > 0) {
        data.data.map((obj) => {
          // for (let i = 0; i < obj.data.length; i++) {
          let arrayObj = {
            Category: obj.name,
            Description: obj.description,
            Scope: obj.scope,
            Severity: obj.severity,
            id: obj._id,
            ...obj,
          };
          SubcategoryList.push(arrayObj);
          // }
        });
        return SubcategoryList;
      } else {
        this.loading = false;
        return [];
      }
    },
    // userRole() {
    //   if (this.$store.getters["auth/getUserRole"]) {
    //     return this.$store.getters["auth/getUserRole"];
    //   } else {
    //     return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
    //   }
    // }
  },
  methods: {
    category() {
      this.id = this.itemObj.id;
      this.issub = true;
    },
  },
  async mounted() {
    console.log("item", this.itemObj);
    // console.log("id",this.itemObj[0].id )
    await this.$store
      .dispatch("servicerequest/fetchsubcategoryList", this.itemObj.id)
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
